export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";